import { GutBodyConnectionsOrgan } from '@repo/types';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
import styles from './GutBodyConnectionsBody.module.css';

/** What a hovered dot opens. Positioning is shared; only the content differs. */
export type GutBodyConnectionsHoverVariant = 'card' | 'pill';

type DotProps = {
  displayName: GutBodyConnectionsOrgan['display_name'];
  hoverVariant?: GutBodyConnectionsHoverVariant;
};

export default function Dot({ displayName, hoverVariant = 'card' }: DotProps) {
  return (
    <span className={styles.dot}>
      {hoverVariant === 'pill' ? (
        <Typography variant='label' color='white' className={styles.pill}>
          {displayName}
        </Typography>
      ) : (
        <>
          <span className={styles.card}>
            <Typography
              variant='label'
              color='darkPurple'
              className={styles.title}
            >
              {displayName}
            </Typography>
          </span>
          <span className={styles.chevron}>
            <Icon name='chevronForward' size={'xs'} color='white' />
          </span>
        </>
      )}
    </span>
  );
}
